import React from "react";
import Card from "react-bootstrap/Card";
import { ImPointRight } from "react-icons/im";
import "./AboutCard.css";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
            Hello! I am <span className="purple">Ashwini Kumar Nayak</span>, based in{" "}
            <span className="purple">Bhubaneswar, India</span>.
            <br />
            I have completed my B.Tech in Computer Science and Engineering from GITAM, Bhubaneswar.
            <br />
            <br />
            Beyond coding, I enjoy engaging in the following activities:
          </p>
          <ul>
            <li className="about-activity">
              <ImPointRight /> Playing games
            </li>
            <li className="about-activity">
              <ImPointRight /> Public speaking
            </li>
            <li className="about-activity">
              <ImPointRight /> Traveling
            </li>
          </ul>

          <p style={{ color: "rgb(155 126 172)" }}>
            I am driven to develop technology that makes a meaningful impact.
          </p>
          <footer className="blockquote-footer">Ashwini</footer>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
